import { useId } from "react";
import { cn } from "@/lib/cn";

interface SijilatyLogoProps {
  size?: "sm" | "md" | "lg";
  showWordmark?: boolean;
  className?: string;
  onDark?: boolean;
}

const iconSizes = { sm: { w: 30, h: 35 }, md: { w: 34, h: 40 }, lg: { w: 42, h: 50 } };

/** Logo colors are fixed brand assets — do not tie to theme tokens. */
const LOGO = {
  docFill: "#1c3464",
  gradStart: "#0c85d0",
  gradMid: "#38b0eb",
  gradEnd: "#16856a",
  lineStroke: "rgba(255,255,255,0.22)",
} as const;

export function SijilatyLogo({ size = "md", showWordmark = true, className, onDark }: SijilatyLogoProps) {
  const gradId = useId();
  const { w, h } = iconSizes[size];

  return (
    <div className={cn("flex items-center gap-3", className)}>
      <svg
        width={w}
        height={h}
        viewBox="0 0 38 44"
        fill="none"
        aria-hidden
        className="shrink-0"
      >
        <defs>
          <linearGradient id={gradId} x1="0" y1="0" x2="1" y2="1">
            <stop offset="0%" stopColor={LOGO.gradStart} />
            <stop offset="55%" stopColor={LOGO.gradMid} />
            <stop offset="100%" stopColor={LOGO.gradEnd} />
          </linearGradient>
        </defs>
        <rect x="0" y="0" width="26" height="34" rx="4" fill={LOGO.docFill} />
        <path
          d="M4 10h13M4 15h17M4 20h10"
          stroke={LOGO.lineStroke}
          strokeWidth="2.5"
          strokeLinecap="round"
        />
        <path
          d="M4 28 Q7 25 10 28 Q13 31 16 27 Q19 24 22 28"
          fill="none"
          stroke={`url(#${gradId})`}
          strokeWidth="1.5"
          strokeLinecap="round"
        />
        <circle cx="28" cy="34" r="10" fill={`url(#${gradId})`} />
        <path
          d="M23.5 34 L26.5 37 L32.5 28.5"
          fill="none"
          stroke="white"
          strokeWidth="1.8"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </svg>
      {showWordmark && (
        <div>
          <div
            className={cn(
              "font-bold leading-none",
              onDark ? "text-white" : "text-ink-1",
              size === "lg" ? "text-lg" : "text-[15px]",
            )}
          >
            سجلاتي
          </div>
          <div
            className={cn(
              "num mt-1 font-semibold uppercase tracking-[3px]",
              onDark ? "text-[#38b0eb]" : "text-ink-3",
              size === "sm" ? "text-[8px]" : "text-[8.5px]",
            )}
          >
            SIJILATY
          </div>
        </div>
      )}
    </div>
  );
}
